// Actions
export const UPDATE_VALUE_SEARCH = "UPDATE_VALUE_SEARCH";
export const CLEAR_CACHE_VALUE_SEARCH = "CLEAR_CACHE_VALUE_SEARCH";
export const CLEAR_CACHE_VALUE_SEARCH_BY_SEARCH = "CLEAR_CACHE_VALUE_SEARCH_BY_SEARCH";
